import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const SimpleViewIcon = (props: IconProps) => (
  <Icon viewBox="0 0 18 18" boxSize={5} {...props}>
    <path
      d="M17 4.5C17.5523 4.5 18 4.94772 18 5.5C18 6.05228 17.5523 6.5 17 6.5H1C0.447715 6.5 0 6.05228 0 5.5C0 4.94772 0.447715 4.5 1 4.5H17Z"
      fill="currentColor"
    />
    <path
      d="M17 11.5C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5H1C0.447715 13.5 0 13.0523 0 12.5C0 11.9477 0.447715 11.5 1 11.5H17Z"
      fill="currentColor"
    />
  </Icon>
);

export default SimpleViewIcon;
